import Pusher from 'pusher-js'

import { PUSHER_APP_KEY, PUSHER_CLUSTER } from '@webapp/infrastructure/envs'
import { type ExportProgress } from '@webapp/models'
import { ExportStatuses } from '@webapp/models/enums/ExportStatus'
import { WSChannelManager } from '../WSChannelManager/WSChannelManager.service'

export interface ExportProgressData {
  total: number
  processed: number
}

export class ExportCSVChannelManager {
  CSVChannelManager: WSChannelManager
  channel: string

  constructor(
    {
      endpoint,
      channel,
      event,
    }: {
      endpoint: string
      channel: string
      event: string
    } = {
      endpoint: '',
      channel: '',
      event: '',
    }
  ) {
    if (!endpoint || !event || !channel) return

    this.CSVChannelManager = new WSChannelManager({
      pusherInstance: new Pusher(PUSHER_APP_KEY, {
        cluster: PUSHER_CLUSTER,
        forceTLS: true,
      }),
    })

    this.channel = channel

    this.CSVChannelManager.subscribe(channel)
    this.CSVChannelManager.channel(channel).bind(event, this._onEvent)
  }

  private _onEvent = (data: ExportProgress) => {
    this.onEvent(data)

    this.onProgress({
      processed: data.index,
      total: data.max,
    })

    if (data.status === ExportStatuses.COMPLETED) {
      this.onComplete(data.file)
    }

    if (data.status === ExportStatuses.ERROR) {
      this.onError(data)
    }
  }

  destroy = () => {
    this.CSVChannelManager.unsubscribe(this.channel)
    this.CSVChannelManager.disconnect()
  }

  /**
   * Overridable Methods
   */
  onEvent = (data: ExportProgress) => undefined
  onProgress = (progress: ExportProgressData) => undefined
  onComplete = (file: ExportProgress['file']) => undefined
  onError = (data: ExportProgress) => undefined
}
